export default function guest({ next, store, _next }) {
    // if(store.getters.auth.loggedIn){
    if (window.localStorage.getItem("rep")) {
        return _next({
            name: 'dashboard'
        })
    }

    return next()
}